<script setup lang="ts">
const emits = defineEmits(['send'])

const visible = ref(false)
const commentContent = ref('')
const isNotAnonymous = ref(false)
const body = ref(null as HTMLElement | null)

const getCheckboxTextClasses = computed(() =>
    isNotAnonymous.value
        ? 'font-medium text-gray-l-900'
        : 'font-normal text-gray-l-700'
)

const show = () => {
    visible.value = true

    if (body.value) {
        body.value.classList.add('overflow-hidden')
    }
}

const hide = () => {
    visible.value = false

    if (body.value) {
        body.value.classList.remove('overflow-hidden')
    }
}

const onClickSend = () => {
    emits('send', commentContent.value, isNotAnonymous.value)
    restoreComment()
    hide()
}

const onClickCancel = () => {
    restoreComment()
    hide()
}

const restoreComment = () => {
    commentContent.value = ''
    isNotAnonymous.value = false
}

onMounted(() => {
    body.value = document.querySelector('body') as HTMLElement
})

defineExpose({ show })
</script>

<template>
    <div
        class="fixed flex items-center justify-center inset-0 bg-gray-600 bg-opacity-20 z-30"
        :class="{ hidden: !visible }"
    >
        <div
            class="relative w-[448px] overflow-auto mx-4 bg-white border border-gray-50 rounded-2xl shadow-md"
        >
            <div
                class="text-twenty-two font-bold text-center leading-6 tracking-light text-gray-l-900 p-4"
            >
                {{ $t('your_comment') }}
            </div>
            <div class="flex flex-col gap-6 pb-0 p-4">
                <textarea
                    v-model="commentContent"
                    class="border border-gray-l-300 rounded-lg w-full h-24 p-2 text-fifteen-exploitation font-normal leading-6 text-gray-l-700 resize-none"
                    required
                />
                <div
                    class="flex gap-2 p-2 cursor-pointer"
                    @click="isNotAnonymous = !isNotAnonymous"
                >
                    <input v-model="isNotAnonymous" type="checkbox" />
                    <p
                        class="text-fifteen-exploitation leading-4.5"
                        :class="getCheckboxTextClasses"
                    >
                        {{ $t('show_username') }}
                    </p>
                </div>
            </div>
            <div class="flex justify-end space-x-2 p-4">
                <ChargemapB2CButton
                    type="secondary"
                    size="large"
                    custom="full-width"
                    @click="onClickCancel"
                >
                    {{ $t('cancel') }}
                </ChargemapB2CButton>
                <ChargemapB2CButton
                    type="primary"
                    size="large"
                    custom="full-width"
                    :disabled="!commentContent"
                    @click="onClickSend"
                >
                    {{ $t('send') }}
                </ChargemapB2CButton>
            </div>
        </div>
    </div>
</template>
